import { RootState } from '@/store/store';
import { ModuleTree } from 'vuex';
import { fhirActions } from './fhir.actions';
import { fhirMutations } from './fhir.mutations';
import { fhirState } from './fhir.state';

export default {
  namespaced: true,
  state: fhirState,
  actions: fhirActions,
  mutations: fhirMutations
} as ModuleTree<RootState>;
